import React from 'react';
import './EngagementMetrics.css';

const EngagementMetrics = ({ data }) => (
  <div className="engagement-metrics">
    <div className="metrics-grid">
      {Object.entries(data || {}).map(([key, value]) => (
        <div key={key} className="metric-item">
          <h4>{key}</h4>
          <span>{value}</span>
        </div>
      ))}
    </div>
  </div>
);

export default EngagementMetrics; 